import { selectCurrentPromoId } from './selectCurrentPromoId';
import { IPromoDetails } from '../../types/promos/promoDetails';
import { IApplicationState } from '../../types/redux';
import { selectPromoDetailsById } from '../promos/promos';

export const selectPromoDetails = (state: IApplicationState): IPromoDetails | null => {
  const selectedId = selectCurrentPromoId(state);

  if (!selectedId) {
    return null;
  }

  return selectPromoDetailsById(selectedId)(state) || null;
};
